import {useEffect, useState} from "react";
import {TOrderDetail} from "../types/types";
import { getOrderHistoryDetail, getNotUserOrderDetail } from '../apis/orders';
import { useUserState } from '../context/UserContext';

const useOrderDetail = (orderNumber: string) => {
    const [order, setOrder] = useState<TOrderDetail>();
    const {isLoggedIn} = useUserState();

    useEffect(() => {
        if (isLoggedIn === true) {
            getOrderDetail()
        } else if (isLoggedIn === false) {
            getNotUserOrderDetail(orderNumber, {
                customerName: localStorage.getItem('customerName')!,
                customerPhone: localStorage.getItem('customerPhone')!,
            }).then(r => setOrder(r.data.payload)).catch(e => console.log(e));
        }
    }, [orderNumber, isLoggedIn])

    const getOrderDetail = () => {
        isLoggedIn
            ? getOrderHistoryDetail(orderNumber).then(r => setOrder(r.data.payload)).catch(e => console.log(e))
            : getNotUserOrderDetail(orderNumber, {
                customerName: localStorage.getItem('customerName')!,
                customerPhone: localStorage.getItem('customerPhone')!,
            }).then(r => setOrder(r.data.payload)).catch(e => console.log(e));
    }

    return {order, setOrder, getOrderDetail}
}

export default useOrderDetail;
